/* eslint-disable react/no-danger */
import React, { useContext } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { includes, isEmpty } from 'lodash';
import { DWTCContext } from '../utils/context';
import { Button } from './styles/Button.styled';

export default function TwoColumnsImageTextCTA({ data, id, dir }) {
  const { title, htmlContent, image, jumpToSection, link } = data;

  const { cssClass } = React.useContext(DWTCContext);
  const [buttonTheme, setButtonTheme] = React.useState('');

  React.useEffect(() => {
    if (includes(cssClass, 'free-zone')) setButtonTheme('red');
    else if (includes(cssClass, 'real-estate')) setButtonTheme('green');
    else setButtonTheme('secondary');
  }, []);

  const columnBtn = link ? (
    <div className="cta-wrapper pt-10 md:pt-14">
      <Button
        stylevariant={buttonTheme}
        href={link.url}
        target={link.target}
        rel=""
        className=""
        dir={dir}>
        {link.name}
      </Button>
    </div>
  ) : null;

  return (
    <section id={jumpToSection} className="bg-[#F7F7F7] py-[50px] md:py-[100px]">
      <div className="container lg:max-[960px] xl:max-w-[1200px] mx-auto px-4 xl:px-0">
        <div className="grid md:grid-cols-2 gap-6">
          {isEmpty(image) || (
            <div>
              <LazyLoadImage src={image.url} />
            </div>
          )}
          <div className="flex items-center">
            <div className="xl:pl-12 2xl:pl-24">
              {isEmpty(title) || (
                <h2 className="text-[#4A4A4A] text-clamp22to30 m-0">{title}</h2>
              )}
              {isEmpty(htmlContent) || (
                <div
                  className="font-DINRegular text-[14px] space-y-5 
                  [&>ol]:list-decimal [&>ol]:pl-3 [&>ol]:text-[#898989] 
                  [&>h3]:text-[#4A4A4A] [&>h3]:text-clamp16to20
                  pt-3 md:pt-7"
                  dangerouslySetInnerHTML={{ __html: htmlContent }}
                />
              )}
              {columnBtn}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
